export default __webpack_public_path__ + "media/shipment/posti-e49b4ef9.svg";